import { t } from '@kso/ui/lib/config/locale';
import emptySearchfile from '@kso/ui/lib/images/empty-searchfile.png';

var errors = {
  'groupNumLimit': t('combine.mainEmp.groupNumLimit'),
  'groupLengthTooShort': t('combine.mainEmp.groupLengthTooShort'),
  'illegalGroupName': t('combine.mainEmp.illegalGroupName'),
  'groupLengthTooLong': t('combine.mainEmp.groupLengthTooLong'),
  'userNotLogin': t('combine.mainEmp.userNotLogin'),
  'InvalidArgument': t('combine.mainEmp.InvalidArgument'),
  'ERR_SERVER_EXCEPTION': t('combine.mainEmp.errServerException'),
  'ServerError': t('combine.mainEmp.ServerError'),
  'LicenseNotFound': t('combine.mainEmp.LicenseNotFound'),
  'LicenseExpired': t('combine.mainEmp.LicenseExpired'),
  'permissionDenied': t('combine.mainEmp.permissionDenied'),
  'DomainExist': t('combine.mainEmp.DomainExist'),
  'CompanymMemberNotExist': t('combine.mainEmp.CompanymMemberNotExist'),
  'InvalidCompanyName': t('combine.mainEmp.InvalidCompanyName'),
  'CompanyNameTooLong': t('combine.mainEmp.CompanyNameTooLong'),
  'UserAlreadyExists': t('combine.mainEmp.UserAlreadyExists'),
  'DeptNotEmpty': t('combine.mainEmp.DeptNotEmpty'),
  'GroupMemberExists': t('combine.mainEmp.GroupMemberExists'),
  'GroupMemberLimit': t('combine.mainEmp.GroupMemberLimit'),
  'InvalidAccount': t('combine.mainEmp.InvalidAccount'),
  'downloadTooDeep': '',
  'groupNotExist': t('combine.mainEmp.groupNotExist'),
  'teamLinkNotExist': t('combine.mainEmp.teamLinkNotExist'),
  'notPersonalUser': t('combine.mainEmp.notPersonalUser'),
  'UserNotExists': t('combine.mainEmp.UserNotExists'),
  'fileNameLengthExceed': t('combine.mainEmp.fileNameLengthExceed'),
  'fileNameConflict': t('combine.mainEmp.fileNameConflict'),
  'fileNotExists': t('combine.mainEmp.fileNotExists'),
  'notGroupMember': t('combine.mainEmp.notGroupMember'),
  'illegalFname': t('combine.mainEmp.illegalFname'),
  'illegalLinkFolderName': t('combine.mainEmp.illegalLinkFolderName'),
  'fileNameEmpty': t('combine.mainEmp.fileNameEmpty'),
  'moveFilePermission': t('combine.mainEmp.moveFilePermission'),
  'moveFileSelfPermission': t('combine.mainEmp.moveFileSelfPermission'),
  'lightLinkExist': t('combine.mainEmp.lightLinkExist'),
  'LIGHT_LINK_NOT_EXIST': t('combine.mainEmp.lightLinkNotExist'),
  'SecretGroupPermissionDenied': t('combine.mainEmp.SecretGroupPermissionDenied'),
  'checkPerFail': t('combine.mainEmp.checkPerFail'),
  'noFolderOperatePermission': t('combine.mainEmp.noFolderOperatePermission'),
  'noNewFilePermission': t('combine.mainEmp.noNewFilePermission'),
  // account
  'MustHasOneBind': t('combine.mainEmp.MustHasOneBind'),
  'apiRateLimitExceede': t('combine.mainEmp.apiRateLimitExceede'),
  'SMSLimitReached': t('combine.mainEmp.SMSLimitReached'),
  // 'InvalidArgument': '必填字段',
  'InvalidPhone': t('combine.mainEmp.InvalidPhone'),
  'PhoneAlreadyInUsed': t('combine.mainEmp.PhoneAlreadyInUsed'),
  'CellPhoneAlreadyInUsed': t('combine.mainEmp.CellPhoneAlreadyInUsed'),
  'InvalidEmail': t('combine.mainEmp.InvalidEmail'),
  'EmailAlreadyInUsed': t('combine.mainEmp.EmailAlreadyInUsed'),
  'InvalidBindCode': t('combine.mainEmp.InvalidBindCode'),
  'EmailAlreadyExists': t('combine.mainEmp.EmailAlreadyExists'),
  'must has an email account': t('combine.mainEmp.hasEmailAccount'),
  'invalid verify code': t('combine.mainEmp.invalidVerifyCode'),
  'PasswordWeak': t('combine.mainEmp.PasswordWeak'),
  'UserHasBindedPhone': t('combine.mainEmp.UserHasBindedPhone'),
  'CellPhoneBind': t('combine.mainEmp.CellPhoneBind'),
  'value of required argument can\'t not be empty': t('combine.mainEmp.codeNotEmpty'),
  'InvalidEmailCode': t('combine.mainEmp.InvalidEmailCode'),
  'InvalidSMSCode': t('combine.mainEmp.InvalidSMSCode'),
  'UserHasBindedEmail': t('combine.mainEmp.UserHasBindedEmail'),
  'EmailNotExists': t('combine.mainEmp.EmailNotExists'),
  'InvalidToken': t('combine.mainEmp.InvalidToken'),
  'InvalidNickname': t('combine.mainEmp.InvalidNickname'),
  'wrongPassword': t('combine.mainEmp.wrongPassword'),
  'chkCodeReset': t('combine.mainEmp.chkCodeReset'),
  'commentLengthTooLong': t('combine.mainEmp.commentLengthTooLong'),
  '_shareFail': t('combine.mainEmp.shareFail'),
  'commentTooLong': t('combine.mainEmp.commentTooLong'),
  'moveFilesFail': t('combine.mainEmp.moveFilesFail'),
  'linkClosed': t('combine.mainEmp.linkClosed'),
  'FileNoExists': t('combine.mainEmp.FileNoExists'),
  'IPCError': t('combine.mainEmp.IPCError'),
  'IOError': t('combine.mainEmp.IOError'),
  'batchDownloadTooDeep': t('combine.mainEmp.batchDownloadTooDeep'),
  'batchDownloadFailed': t('combine.mainEmp.batchDownloadFailed'),
  'batchDownloadEmptyFolder': t('combine.mainEmp.batchDownloadEmptyFolder'),
  'batchDownloadEmpty': t('combine.mainEmp.batchDownloadEmpty'),
  'fileSearchNoPermission': t('combine.mainEmp.fileSearchNoPermission'),
  'copyFileFail': t('combine.mainEmp.copyFileFail'),
  'noCopyMultiFolders': t('combine.mainEmp.noCopyMultiFolders'),
  'copyTooDeep': t('combine.mainEmp.copyTooDeep'),
  'fileTaskFailed': t('combine.mainEmp.fileTaskFailed'),
  'fileTaskNumLimit': t('combine.mainEmp.fileTaskNumLimit'),
  'fileTaskNotExist': t('combine.mainEmp.fileTaskNotExist'),
  'fileTaskDuplicated': t('combine.mainEmp.fileTaskDuplicated'),
  // usercenter
  'NicknameTooLong': t('combine.mainEmp.NicknameTooLong'),
  'InvalidSsid': t('combine.mainEmp.InvalidSsid'),
  'userContracted': t('combine.mainEmp.userContracted'),
  'fileImportSameAccount': t('combine.mainEmp.fileImportSameAccount'),
  'HaveNotVerify': t('combine.mainEmp.HaveNotVerify'),
  'InvalidVerifyCode': t('combine.mainEmp.InvalidVerifyCode'),
  'SsidIsMissing': t('combine.mainEmp.SsidIsMissing'),
  'SsidParamError': t('combine.mainEmp.SsidParamError'),
  'GetAccountMergeUserInfoFailed': t('combine.mainEmp.GetAccountMergeUserInfoFailed'),
  'ReportAccountMergeFailed': t('combine.mainEmp.ReportAccountMergeFailed'),
  'CanNotMergeUsersFromDiffrentCompany': t('combine.mainEmp.CanNotMergeUsersFromDiffrentCompany'),
  'CanNotMergerUsersFromThisCompany': t('combine.mainEmp.CanNotMergerUsersFromThisCompany'),
  'QueryPermittedDocumentFaild': t('combine.mainEmp.QueryPermittedDocumentFaild'),
  'CanNotGetLoginUserInfo': t('combine.mainEmp.CanNotGetLoginUserInfo'),
  'InconsistentAccount': t('combine.mainEmp.InconsistentAccount'),
  'IrregularOauthBinded': t('combine.mainEmp.IrregularOauthBinded'),
  // 协作组
  'ErrLinkShareGroupNotFound': t('combine.mainEmp.ErrLinkShareGroupNotFound'),
  'ErrGroupCountExceedLimit': t('combine.mainEmp.ErrGroupCountExceedLimit'),
  'ErrLinkShareGroupMemberNotFound': t('combine.mainEmp.ErrLinkShareGroupMemberNotFound')
};

var exception = function exception(input) {
  var err = '';
  if (typeof input === 'string') {
    err = errors[input];
  } else if (input && input.response) {
    var _ref = input.response || {},
      data = _ref.data,
      status = _ref.status;
    var _ref2 = data || {},
      result = _ref2.result,
      msg = _ref2.msg;
    if (status >= 400 && status < 500) {
      err = errors[result] || msg;
    }
  }
  return err || errors.ERR_SERVER_EXCEPTION;
};

var HANDER = {
  permissionDenied: function permissionDenied(input) {
    var _ref = input || {},
      response = _ref.response;
    var _ref2 = response || {},
      data = _ref2.data;
    if (data && data.faillist) {
      return data.faillist[0].msg;
    }
    return exception(input);
  }
};
var FinderMainEmpty = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "k-finder-main-empty"
    }, [_vm.error ? _c('div', {
      staticClass: "list-process error"
    }, [_vm._v("\n    " + _vm._s(_vm.errorTxt) + "\n  ")]) : _vm.isSearch && _vm.loading ? _c('div', {
      staticClass: "list-process loading"
    }, [_vm._v("\n    " + _vm._s(_vm.lang_searching) + "\n  ")]) : !_vm.loading && _vm.isEmpty ? _c('div', {
      staticClass: "list-process empty"
    }, [_vm.isLatest ? _c('div', [_vm._v("\n      " + _vm._s(_vm.lang_latestHere) + "\n    ")]) : _vm.isSearch ? _c('div', [_c('img', {
      staticClass: "empty-searchfile",
      attrs: {
        "src": _vm.emptySearchfile
      }
    }), _vm._v(" "), _c('div', [_vm._v("\n        " + _vm._s(_vm.lang_noFindContain) + _vm._s(_vm.source.keyword) + _vm._s(_vm.lang_de) + _vm._s(_vm.emptyText) + "\n      ")])]) : _c('div', [_vm._v(_vm._s(_vm.lang_pitera) + _vm._s(_vm.emptyText))])]) : _vm._e()]);
  },
  staticRenderFns: [],
  name: 'KFinderMainEmpty',
  componentsName: 'KFinderMainEmpty',
  props: {
    loading: {
      type: Boolean
    },
    source: {
      type: Object
    },
    items: {
      type: Array
    },
    error: {
      type: String
    },
    isSelectFile: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      emptySearchfile: emptySearchfile,
      lang_searching: t('combine.mainEmp.searching'),
      lang_latestHere: t('combine.mainEmp.latestHere'),
      lang_noFindContain: t('combine.mainEmp.noFindContain'),
      lang_de: t('combine.mainEmp.de'),
      lang_pitera: t('combine.mainEmp.pitera')
    };
  },
  computed: {
    emptyText: function emptyText() {
      return this.isSelectFile ? t('combine.mainEmp.file') : t('combine.mainEmp.finder');
    },
    isSearch: function isSearch() {
      return this.source.routeName === 'Search';
    },
    isLatest: function isLatest() {
      return this.source.routeName === 'Latest';
    },
    isEmpty: function isEmpty() {
      return !this.items || !this.items.length;
    },
    errorTxt: function errorTxt() {
      if (this.error.silent) {
        return;
      }
      var _ref3 = this.error || {},
        response = _ref3.response;
      var _ref4 = response || {},
        data = _ref4.data;
      var _ref5 = data || {},
        result = _ref5.result;
      var newError;
      if (!result && typeof data === 'string') {
        newError = data || {};
      }
      newError = newError || this.error;
      return result && (HANDER[result] && HANDER[result]() && HANDER[result](newError) || exception(newError)) || '获取数据失败';
    }
  }
};

FinderMainEmpty.install = function (Vue) {
  Vue.component(FinderMainEmpty.name, FinderMainEmpty);
};

export { FinderMainEmpty as default };
